import { api, errorMessage } from "@/lib/api";
import { toast } from "sonner";

export const ENTITY_PATH = { company: "/clienti", quote: "/offerte", order: "/ordini", contract: "/contratti", intervention: "/interventi",
  report: "/rapportini", asset: "/prodotti-asset", license: "/licenze" };

export const fmtSize = (b) => (b >= 1048576 ? `${(b / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round(b / 1024))} KB`);

// download solo tramite endpoint autorizzato (cookie di sessione), mai URL pubblici
export const downloadDocument = async (id, version, filename) => {
  try {
    const r = await api.get(`/documents/${id}/download`, { params: version ? { version } : {}, responseType: "blob" });
    const url = URL.createObjectURL(r.data);
    const a = document.createElement("a");
    a.href = url; a.download = filename || "documento"; a.click();
    setTimeout(() => URL.revokeObjectURL(url), 2000);
  } catch (e) { toast.error(errorMessage(e)); }
};
